export default (path) => {
  let { pathname: windowPath } = window.location;
  // if has trailing slash
  if (windowPath.charAt(windowPath.length - 1) === '/') {
    windowPath = windowPath.substring(0, windowPath.length - 1);
  }

  return windowPath + path;
};
